import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-modal-status-app',
  templateUrl: './modal-status-app.page.html',
  styleUrls: ['./modal-status-app.page.scss'],
})
export class ModalStatusAppPage implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
